
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SingleSelectNpsGraphTypeV1 {
  export enum SingleSelectNpsGraphTypeV1 {
    GAUGE = "GAUGE",
    NONE = "NONE",
    PROPORTION_WITH_HORIZONTAL_BAR = "PROPORTION_WITH_HORIZONTAL_BAR",
    PROPORTION_WITH_VERTICAL_BAR = "PROPORTION_WITH_VERTICAL_BAR",
  }

  export interface SingleSelectNpsGraphTypeV1DTO {
    case: string;
  }

  export const fromDTO = (dto: SingleSelectNpsGraphTypeV1DTO): SingleSelectNpsGraphTypeV1 => {
    if (dto === undefined || dto === null) {
      throw new InvalidSingleSelectNpsGraphTypeV1Error(
        `Invalid DTO ${dto} provided for SingleSelectNpsGraphTypeV1.SingleSelectNpsGraphTypeV1`
      );
    }
    switch (dto.case) {
      case "GAUGE":
        return SingleSelectNpsGraphTypeV1.GAUGE;
      case "NONE":
        return SingleSelectNpsGraphTypeV1.NONE;
      case "PROPORTION_WITH_HORIZONTAL_BAR":
        return SingleSelectNpsGraphTypeV1.PROPORTION_WITH_HORIZONTAL_BAR;
      case "PROPORTION_WITH_VERTICAL_BAR":
        return SingleSelectNpsGraphTypeV1.PROPORTION_WITH_VERTICAL_BAR;
      default:
        throw new InvalidSingleSelectNpsGraphTypeV1Error(
          `Case ${dto.case} is not valid case of SingleSelectNpsGraphTypeV1.SingleSelectNpsGraphTypeV1`
        );
    }
  };

  export const toDTO = (singleSelectNpsGraphTypeV1: SingleSelectNpsGraphTypeV1): SingleSelectNpsGraphTypeV1DTO => {
    const enumDTO = {
      case: SingleSelectNpsGraphTypeV1[singleSelectNpsGraphTypeV1],
    };
    return enumDTO;
  };
}

export class InvalidSingleSelectNpsGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsGraphTypeV1Error";
  }
}
export class InvalidSingleSelectNpsGraphTypeV1GaugeError extends InvalidSingleSelectNpsGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsGraphTypeV1GaugeError";
  }
}

export class InvalidSingleSelectNpsGraphTypeV1NoneError extends InvalidSingleSelectNpsGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsGraphTypeV1NoneError";
  }
}

export class InvalidSingleSelectNpsGraphTypeV1ProportionWithHorizontalBarError extends InvalidSingleSelectNpsGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsGraphTypeV1ProportionWithHorizontalBarError";
  }
}

export class InvalidSingleSelectNpsGraphTypeV1ProportionWithVerticalBarError extends InvalidSingleSelectNpsGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsGraphTypeV1ProportionWithVerticalBarError";
  }
}
